module.exports = __webpack_public_path__ + "static/media/normal_fit.d5e74240.svg";